import request from '@/utils/request'

/** 获取appid列表 **/
export const getappIdListAsync = (data) => {
  return request({
    url: 'tools/v1/appSecret/page',
    method: 'GET',
    params: data
  })
}

/** 新增/修改appid **/
export const addAppIdAsync = (data) => {
  return request({
    url: 'tools/v1/appSecret',
    method: 'POST',
    data
  })
}
// 自动补全租户名称
export const getTenantNameListAsync = (params) => {
  return request({
    url: '/sys/v1/tenant/page',
    method: 'GET',
    params
  })
}
// 删除appid
export const deleteAppIdAsync = (id) => {
  return request({
    url: `tools/v1/appSecret/${id}`,
    method: 'DELETE'
  })
}
